var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"authenticAtionPending"},[_c('div',{staticClass:"title"},[_vm._v(" 实名认证检测中 ")]),_c('div',{staticClass:"logo"},[_c('div',{staticClass:"custom-loading-circle"}),_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/style/idCardLoading-bg.png"),"alt":""}})]),_c('div',{staticClass:"tip"},[_vm._v(" 你的身份信息已提交，请耐心等待 ")])])
}]

export { render, staticRenderFns }